class Alert {
  constructor(message, fixed) {
    this.message = message;
    this.expired = false;
    this.fixed = fixed;
  }

  setExpired() {
    this.expired = true;
  }

  setID(id) {
    this.id = id;
  }
}

export default Alert;
